var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_78",
    "data-name": "Group 78",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.119,
    height: 66.068,
    viewBox: "0 0 31.119 66.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M4792.164,12h12.791a9.192,9.192,0,0,1,9.165,9.168V48.415a9.192,9.192,0,0,1-9.165,9.164h-12.791A9.192,9.192,0,0,1,4783,48.415V21.168A9.192,9.192,0,0,1,4792.164,12Zm12.791,2.036h-12.791a7.153,7.153,0,0,0-7.127,7.131V48.415a7.153,7.153,0,0,0,7.127,7.128h12.791a7.153,7.153,0,0,0,7.128-7.128V21.168a7.153,7.153,0,0,0-7.128-7.131Z",
    transform: "translate(-4783 -12)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M8755.036,2541v8.769H8753V2541Z",
    transform: "translate(-8738.459 -2531.737)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M8755,9594h2.021v26.954H8755Z",
    transform: "translate(-8740.451 -9558.903)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M7636.044,15678.717,7631,15671.3l1.5-1.3,2.788,4.18,1.513-.052,2.794-4.048,1.667,1.184Z",
    transform: "translate(-7620.568 -15612.648)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.f26462d7064deecb7532546043419547.svg";
export { ForwardRef as ReactComponent };